<form [formGroup]="braceletForm" class="dialog-form" class="text-center">
    <h3>Informe a pulseira do usuário que deseja verificar:</h3>
    <div class="form-control">
        <input class="text-center" style="width: 90%;margin-bottom: 30px;" type="text" autocomplete="off" formControlName="bracelet"
            name="bracelet" pInputText id="bracelet" #bracelet (keyup.enter)="getUserByBracelet()">
    </div>
    <div>
        <p class="text-center">{{user.firstName}} {{user.lastName}}</p>
    </div>
</form>